const Download = () => <div></div>

Download.getInitialProps = async ctx => {
  let route
  const isServer = !!ctx.req

  const ua = isServer
    ? ctx?.req?.headers['user-agent']
    : window.navigator.userAgent

  var isAndroid = ua.indexOf('android') > -1

  if (isAndroid) {
    route = 'https://play.google.com/store/apps/details?id=com.citifyd.Citifyd'
  } else {
    route = 'https://itunes.apple.com/us/app/citifyd/id984113093?ls=1&mt=8'
  }

  if (ctx.res) {
    ctx.res.writeHead(302, { Location: route })
    ctx.res.end()
  } else {
    window.location.replace(route)
  }

  return {}
}

export default Download
